import  { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singletonHook } from 'react-singleton-hook';
import * as LocationActions from "../redux/actions/LocationAction";
import _ from 'lodash'

let data = {}
const useLocationServicesFn = ()=>{  
    const [isLocationsInitialized, setIsLocationsInitialized] = useState(false)
    data = useSelector((state) => {
        return {states: state.location.states,
            locations: _.sortBy(state.location.locations, "name"),
            programs: state.location.programs,
            primaryLocationId:state.location.primaryLocationId,
            isLocationsInitialized
        };
    });

    const token = useSelector((state)=>{
        return state.auth.token;
    })

    const dispatchSetup = useDispatch();
    const GetLocations = useCallback(async () => {       
        var action = await LocationActions.GetLocations();
        dispatchSetup(action);       

    }, [dispatchSetup])

    const GetStates = useCallback(async () => {       
        var action = await LocationActions.GetStates();
        dispatchSetup(action);       

    }, [dispatchSetup])

    const GetPrograms = useCallback(async () => {       
        var action = await LocationActions.GetPrograms();
        dispatchSetup(action);       

    }, [dispatchSetup])



    useEffect(()=>{  
        if(token){      
            GetLocations().then(()=>{
                setIsLocationsInitialized(true);               
            });
            GetStates();  
            GetPrograms();           
        }   
    }, [ GetLocations, GetStates, GetPrograms, token])

    return data
}

export const useLocationServices = singletonHook(data, useLocationServicesFn);;